import { Center, Spinner, Text } from '@chakra-ui/react';
import React from 'react'
import { useAppContext } from '../../App';

export default function CustomLoader({
  loaderText = "CARGANDO...",
  customStyles = {},
}) {
    const {isMobile} = useAppContext();
  const style = styles(customStyles, isMobile);
  return (
    <Center h="100vh" {...style.container}>
      <Text className='quicksand-semibold' {...style.text}>{loaderText}</Text>
      <Spinner {...style.spinner} size="xl" color="cyan.400" />
    </Center>
  );
}

const styles = (customStyles, isMobile) => ({
  container: {
    display: "flex",
    height: "20vh",
    ...customStyles.container
  },
  text: {
    color: "white",
    fontWeight: "bold",
    marginRight: isMobile? "1rem":"3rem",
    ...customStyles.text
  },
  spinner: {
    ...customStyles.spinner
  }
});
